import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface MiniLoaderProps {
  size?: number;
  className?: string;
}

const MiniLoader: React.FC<MiniLoaderProps> = ({ 
  size = 24, 
  className = '' 
}) => {
  return (
    <Box className={`mini-loader-container ${className}`} data-testid="mini-loader">
      <CircularProgress 
        size={size} 
        className="mini-loader-spinner"
      />
    </Box>
  );
};

export default MiniLoader;